import React from "react";
import MatchSummary from "./MatchSummary";
import PoolInformation from "./PoolInformation";
import { getPrettyDate } from "../lib/format";

// BET NOW while the pool is open, VIEW LIVE once it has closed, otherwise nothing.
const statusButton = (item) => {
  if (item.poolStatus === "OPEN") {
    return (
      <a
        href={"https://www.tab.co.za/tabs/soccer/" + item.programDate + "/" + item.programCode + "/" + item.race}
        className="button button4R tiny right betnowbutton"
        target="_blank"
        rel="noopener noreferrer"
      >
        BET NOW
      </a>
    );
  }
  if (item.poolStatus === "CLOSED") {
    return (
      <a
        href={"/live-pool-projections#" + item.programDate + "_" + item.programCode + "_" + item.race}
        className="button tiny right"
        style={{ backgroundColor: "#e8004c" }}
        rel="noopener noreferrer"
      >
        VIEW LIVE
      </a>
    );
  }
  return "";
};

const PoolItem = ({ item }) => {
  return (
    <div>
      <div className="pooldateindicator4R">
        {getPrettyDate(item.programDate)} - {item.PartitionKey.replaceAll("S11 ", "Mega 10 ")}
      </div>
      <table className="pooltable">
        <tbody>
          <tr>
            <th>Match</th>
            <th>Team A</th>
            <td style={{ textAlign: "center" }}>v</td>
            <th className="righttext">Team B</th>
          </tr>
          {JSON.parse(item.matches).map((match) => (
            <MatchSummary item={match} pool_title={item.PartitionKey} />
          ))}
        </tbody>
      </table>
      <PoolInformation item={item} statusButton={statusButton(item)} />
    </div>
  );
};

export default PoolItem;
